import * as z from 'zod';

import { tcConditionQuerySchema } from '@/_pages/settings/terms-conditions/shared/schemas';
import { paginatedResponseSchema } from '@/_schemas/generic/paginated-response';
import { statusQuerySchema } from '@/_schemas/status-input';

import { tcTemplateQueryLinkerSchema } from './tc-template-query-link-schema';

export const tcTemplateQuerySchema = z.object({
  ...tcTemplateQueryLinkerSchema.shape,
  sku: z.string(),
  notes: z.string(),
  status: statusQuerySchema,
  terms_conditions: z.array(tcConditionQuerySchema),
  agreements_count: z.number(),
});

export type TcTemplateQuerySchema = z.infer<typeof tcTemplateQuerySchema>;

export const tcTemplateQueryAllSchema = paginatedResponseSchema(tcTemplateQuerySchema);

export type TcTemplateQueryAllSchema = z.infer<typeof tcTemplateQueryAllSchema>;
